var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (value) {if (value.$total) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = value.$total.text) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else
if (value.name) {
if (value.baseCampaignName) {
pug_html = pug_html + "\u003Cdiv class=\"base-campaign-name\"\u003E" + (pug.escape(null == (pug_interp = value.baseCampaignName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (value.isForVNext) {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes(["scope-navigator",value.className], [false,true]), false, true)+pug.attr("href", value.href, true, true)+pug.attr("data-campaignid", value.cmpid, true, true)+pug.attr("aria-label", value.ariaLabel, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = value.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", value.href, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = value.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp));
}}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;